import { Box, Stack, Text } from '@chakra-ui/react'
import { SectionTitle } from '../section-title'
import { TeamGallery } from './team-gallery'

const data = {
  paragraph:
    'We are a tight knit team of passionate music lovers, tech geeks and art buffs. From copyright lawyers to creative producers and investment professionals, we are shaping the Web 3.0 revolution in music one token at a time.',
}

export const TeamOverview = () => {
  return (
    <Stack bgColor="txtBlack" w="full" h="full" alignItems="center" gap="4rem" p={['2rem', '4rem']}>
      <Stack
        w="full"
        direction={['column', 'column', 'column', 'row']}
        gap={['4rem', '4rem', '4rem', 0]}
      >
        <Box w={['full', 'full', 'full', '33%']}>
          <SectionTitle title="The Core Team" />
        </Box>
        <Text
          color="txtWhite"
          w={['full', 'full', 'full', '25%']}
          overflowWrap="break-word"
          fontSize="lg"
        >
          {data.paragraph}
        </Text>
      </Stack>
      <TeamGallery />
    </Stack>
  )
}
